<div #searchItem class="search-item" [ngClass]="{'viewMap': viewMap}">
    <div class="flex jc-sb ai-b wrapper">
        <div class="w-100">
            <div class="mapfre-fs-l-r dark flex cp" (click)="googleMapService.openInfoWindow(input)">
                <div [ngClass]="{
                    'w-100':!viewMap,
                    'w-80':viewMap,
                    'primary':input.selected}"> {{input?.nombreProfesionalSanitario || input?.nombreWeb }}
                </div>
                <div [ngClass]="{
                    'mapfre-hide-desktop': !viewMap}" class="mapfre-fs-xs dark-blue distance">
                    {{utils.getKmDistance(input?.distancia)}}
                </div>
            </div>
            <div class="flex ai-c mapfre-mt-s">
                <div class="mapfre-fs-xs gray1 address">
                    <div *ngIf="input?.nombreProfesionalSanitario">{{input?.nombreWeb}}</div>
                    <div class="flex jc-c ai-c">
                        {{ this.medicalCenterHelper.getCompleteAddress(this.input) }}
                    </div>
                </div>
                <div [ngClass]="{'mapfre-hide': viewMap}" class="search-item__divider mapfre-hide-mobile"></div>
                <div [ngClass]="{'mapfre-hide': viewMap}" class="mapfre-fs-xs dark-blue mapfre-hide-mobile">
                    {{utils.getKmDistance(input?.distancia)}}</div>
            </div>

            <div class="mapfre-fs-s mapfre-mt-sm gray1 flex"
                *ngIf="state?.searchParams?.speciality?.codigoEspecialidad && input.videoconsulta">
                <img src="assets/icons/video_consultation.svg" alt="">
                <div class="mapfre-ml-xs"> Videoconsulta disponible</div>
            </div>
        </div>
        <div class="flex search-item__chips chips f-wrap" [ngClass]="{'w-80':!viewMap}">
            <app-chip *ngIf="utils.showOnlineMeeting(input, state)" [text]="'Cita online'"></app-chip>
            <app-chip *ngIf="input.indMapfreSalud" type="primary" [text]="'Centro Médico Mapfre'"></app-chip>
            <app-chip *ngIf="input.indUrgencias && state.tabIndex === 0 && (state.searchEngineType !== 'emergency-center' && state.searchEngineType !== 'additional-services')" [text]="'Urgencias'"></app-chip>

        </div>
        <div class="search-item__buttons buttons w-100 flex">
            <app-button (click)="onMoreInfo()" [text]="'Más información'"></app-button>
            <app-button (click)="medicalCenterHelper.requestMedicalAppointment(input,state)" *ngIf="utils.showOnlineMeeting(input, state)"
                type="outline-primary" ml="10" [text]="'Pedir cita'"></app-button>

        </div>
    </div>
</div>
